import { useTranslation } from "react-i18next";
import cn from "classnames";

import { Typography } from "shared/ui/components/Typography";
import { Button } from "shared/ui/components/Button";

import { AuthMessageProps } from "./AuthMessage.types";

import styles from "./AuthMessage.module.scss";

const AuthMessage = ({ className }: AuthMessageProps) => {
  const { t } = useTranslation();

  return (
    <div className={cn(styles.authMessage, className)}>
      <div className={styles.authMessageOverlay}>
        <div className={styles.authMessageContent}>
          <Typography
            className={styles.authMessageTitle}
            variant="h4"
            weight="semiBold"
          >
            Ergebnisse inkl. Förderungen vergleichen
          </Typography>
          <Typography
            className={styles.authMessageText}
            variant="bodyM"
            weight="regular"
          >
            Erhalten Sie eine kostenlose Analyse mit allen Berechnungen von einem Experten. Kontaktieren Sie uns: 
          </Typography>
          <Button
            variant="black"
            className={styles.authMessageButton}
            component={"a"}
            href="/kontakte"
          >
            {t("Experten kontaktieren")}
          </Button>
        </div>
      </div>

    </div>
  );
};

export default AuthMessage;
